import { createLookupTable } from '../utils';

const statuses = {
  in_progress: 'info',
  in_review: 'warning',
  in_concept: 'inactive',
  is_closed: 'success',
  is_cancelled: 'error',
} as const;

export type ClaimLabel = keyof typeof claimTable;
export const claimTable = createLookupTable(statuses, 'claim');
